import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Row,
  Input,
  Button,
  Form,
  Layout,
  Col,
  message,
  Tabs,
  Select,
  Modal,
  Spin,
} from "antd";
import api from "./../../Api";
import languages from "../Languages/languages.json";
import slugify from "slugify";

const { Content } = Layout;
const { Option } = Select;
const { TextArea } = Input;
const { TabPane } = Tabs;

const useCategories = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const getCategories = async () => {
      let search = window.location.search;
      let params = new URLSearchParams(search);
      let categoryID = params.get("categoryID");
      const { data } = await api.categories().get();
      setCategories(data.filter((x) => x.id !== parseInt(categoryID)));
    };
    getCategories();
  }, []);
  return {
    categories,
  };
};

const useUpdateForm = (defaultValues) => {
  const [inputs, setInputs] = useState({ ...defaultValues });
  const [translate, setTranslate] = useState(
    inputs.translate !== null ? inputs.translate : { name: "", description: "" }
  );
  const [modal, setModal] = useState({
    ModalText: "Confirm category delete",
    visible: false,
    confirmLoading: false,
  });

  const handleSubmit = (event) => {
    event.preventDefault();

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let categoryID = params.get("categoryID");
    //const postUrl = `${API_URL}/categories/`;
    let data = {
      id: parseInt(categoryID),
      code: inputs.code,
      name: inputs.name,
      description: inputs.description,
      translate: translate,
      parentId: inputs.parentId,
      slug: slugify(inputs.name, {
        lower: true,
      }),
    };
    api
      .categories()
      .post(data)
      .then(async (res) => {
        await message.success("This category successfully edited", 1);
        window.location.reload();
      });
  };

  const history = useHistory();

  const showModal = () => {
    setModal((modal) => ({
      ...modal,
      visible: true,
    }));
  };
  const handleModalOk = async () => {
    setModal((modal) => ({
      ...modal,
      ModalText: "Please wait...",
      confirmLoading: true,
    }));
    setTimeout(() => {
      setModal((modal) => ({
        ...modal,
        visible: false,
        confirmLoading: false,
      }));
    }, 2000);
    await api.categories(inputs.id).delete();
    await message.warning("This category successfully deleted", 1);
    history.push(`/categories`);
    window.location.reload();
  };

  const handleModalCancel = () => {
    setModal((modal) => ({
      ...modal,
      visible: false,
    }));
  };

  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({
      ...inputs,
      [event.target.name]: event.target.value,
    }));
  };

  const handleCategoryChange = (value) => {
    setInputs((inputs) => ({
      ...inputs,
      parentId: value,
    }));
  };

  const handleInputTranslateChange = (event) => {
    event.persist();
    setTranslate((translate) => ({
      ...translate,
      code: "hy",
      [event.target.name]: event.target.value,
    }));
  };
  return {
    handleSubmit,
    handleModalOk,
    handleModalCancel,
    showModal,
    modal,
    handleInputChange,
    handleCategoryChange,
    inputs,
    translate,
    handleInputTranslateChange,
  };
};

const CategoryForm = ({ category }) => {
  const {
    inputs,
    handleModalOk,
    handleModalCancel,
    showModal,
    modal,
    translate,
    handleInputChange,
    handleCategoryChange,
    handleSubmit,
    handleInputTranslateChange,
  } = useUpdateForm(category);
  const { categories } = useCategories();

  const callback = (key) => {
    console.log(key);
  };
  return (
    <Tabs defaultActiveKey="1" onChange={callback}>
      {languages.map((language) => {
        return (
          <TabPane tab={language.name} key={language.id}>
            <Form onSubmit={handleSubmit}>
              <Form.Item label="Code">
                <Input
                  type="text"
                  name="code"
                  onChange={handleInputChange}
                  value={inputs.code}
                />
              </Form.Item>
              <Form.Item label="Category name">
                <Input
                  type="text"
                  name="name"
                  onChange={
                    language.id === 1
                      ? handleInputChange
                      : handleInputTranslateChange
                  }
                  value={language.id === 1 ? inputs.name : translate.name}
                />
              </Form.Item>
              <Form.Item label="Description">
                <TextArea
                  type="text"
                  name="description"
                  autosize={{ minRows: 3, maxRows: 50 }}
                  onChange={
                    language.id === 1
                      ? handleInputChange
                      : handleInputTranslateChange
                  }
                  value={
                    language.id === 1
                      ? inputs.description
                      : translate.description
                  }
                />
              </Form.Item>
              <Form.Item label="Parent category">
                <Select
                  name="categoryId"
                  style={{ width: "100%" }}
                  placeholder="Please select category"
                  onChange={handleCategoryChange}
                  value={inputs.parentId}
                >
                  <Option value={0}>None</Option>
                  {categories.map((cat) => (
                    <Option value={cat.id} key={cat.id}>
                      {cat.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label="Slug">
                <Input
                  name="slug"
                  type="text"
                  onChange={handleInputChange}
                  value={inputs.slug}
                  disabled
                />
              </Form.Item>
              <Row type="flex" gutter={32}>
                <Col>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Update
                    </Button>
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item>
                    <Button type="danger" onClick={showModal}>
                      Delete
                    </Button>
                    <Modal
                      title="Are you sure?"
                      visible={modal.visible}
                      onOk={handleModalOk}
                      confirmLoading={modal.confirmLoading}
                      onCancel={handleModalCancel}
                    >
                      <p>{modal.ModalText}</p>
                    </Modal>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </TabPane>
        );
      })}
    </Tabs>
  );
};

const Category = () => {
  const [category, setCategory] = useState({});
  const [spinning, setSpinning] = useState(true);

  useEffect(() => {
    const fetchCategory = async () => {
      let search = window.location.search;
      let params = new URLSearchParams(search);
      let categoryID = params.get("categoryID");

      const res = await api.categories(categoryID).get();
      setCategory(res.data[0]);
      setSpinning(false);
    };
    fetchCategory();
  }, []);
  return (
    <div className="category">
      <Spin spinning={spinning} delay={300}>
        <Layout>
          <Content style={{ padding: "32px 50px" }}>
            <Row>
              <Col span={12}>
                <div>
                  <h1>{category.name}</h1>
                  {!!category.id && <CategoryForm category={category} />}
                </div>
              </Col>
              <Col span={12}></Col>
            </Row>
          </Content>
        </Layout>
      </Spin>
    </div>
  );
};
export default Category;
